import { CalendarClock, X } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { GenerateDraftRun } from "@/lib/api";
import { formatDateTimeValue } from "./constants";

interface PendingRolloverSchedulesProps {
  schedules: GenerateDraftRun[];
  isLoading: boolean;
  onCancel: (schedule: GenerateDraftRun) => void;
  isCancelling: boolean;
}

export function PendingRolloverSchedules({
  schedules,
  isLoading,
  onCancel,
  isCancelling,
}: PendingRolloverSchedulesProps) {
  if (isLoading || schedules.length === 0) return null;

  return (
    <Card className="border-border shadow-lg mt-6">
      <CardHeader>
        <CardTitle className="text-lg font-semibold flex items-center gap-2">
          <CalendarClock className="h-5 w-5" /> Agendamentos pendentes
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="rounded-md border border-border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Origem → Destino</TableHead>
                <TableHead>Agendado para</TableHead>
                <TableHead>Criado por</TableHead>
                <TableHead className="text-right">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {schedules
                .slice()
                .sort((a, b) => (a.scheduledAt || "").localeCompare(b.scheduledAt || ""))
                .map((schedule) => (
                  <TableRow key={schedule.runId}>
                    <TableCell className="font-medium">
                      {schedule.sourceYear} → {schedule.targetYear}
                    </TableCell>
                    <TableCell>{formatDateTimeValue(schedule.scheduledAt)}</TableCell>
                    <TableCell>{schedule.triggeredBy || "—"}</TableCell>
                    <TableCell className="text-right">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => onCancel(schedule)}
                        disabled={isCancelling}
                      >
                        <X className="h-4 w-4 mr-1" /> Cancelar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
